import * as L from 'leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';

import utils from './utils';

L.Marker.prototype.options.icon = L.icon({
    iconRetinaUrl: '/images/marker-icon-2x.png',
    iconUrl: '/images/marker-icon.png',
    shadowUrl: '/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
});

class Maps {
    setupMap(coords, zoom)
    {
        let map = L.map('map', {
            center: coords,
            zoom: zoom,
            scrollWheelZoom: false,
        });

        let tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            minZoom: 0,
            maxZoom: 17,
        });

        tiles.addTo(map);

        return map;
    }

    initMaps(container)
    {
        let map_div = $('#map', container);
        if (map_div.length > 0) {
            function splitCoords(node) {
                let coords = node.val();

                if (coords.indexOf(',') != -1) {
                    let coords_exists = coords.split(',');

                    return [
                        parseFloat(coords_exists[0]),
                        parseFloat(coords_exists[1])
                    ];
                }

                return false;
            }

            let zoom = 5;
            let has_marker = false;

            let coords = [
                42.585,
                12.305,
            ];

            if (map_div.hasClass('site')) {
                let coords_exists = $('#coordinates');
                if (coords_exists.length > 0 && coords_exists.val() != '') {
                    coords = splitCoords(coords_exists);
                    zoom = 10;
                    has_marker = true;
                }

                let map = this.setupMap(coords, zoom);

                if (has_marker) {
                    L.marker(coords).addTo(map);
                }

                const search = new GeoSearchControl({
                    style: 'bar',
                    searchLabel: $('[name=address]').val(),
                    provider: new OpenStreetMapProvider(),
                    marker: {
                        icon: L.Marker.prototype.options.icon,
                        draggable: true,
                    },
                });

                map.addControl(search);

                map.on('geosearch/showlocation', (e) => {
                    $('[name=address]').val(e.location.label);
                    let new_coordinates = e.location.y + ',' + e.location.x;
                    $('#coordinates').val(new_coordinates);
                }).on('geosearch/marker/dragend', (e) => {
                    let new_coordinates = e.location.lat + ',' + e.location.lng;
                    $('#coordinates').val(new_coordinates);
                });
            }
            else if (map_div.hasClass('customer')) {
                let map = this.setupMap(coords, zoom);
                let bounds = [];

                $('input:hidden[name=coordinates]').each(function() {
                    let coords = splitCoords($(this));
                    if (coords) {
                        L.marker(coords).addTo(map);
                        bounds.push(coords);
                    }
                });

                if (bounds.length > 0) {
                    map.fitBounds(bounds);
                    map.setZoom(map.getZoom() - 1);
                }
            }
        }
    }
}

export default Maps;
